// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2GW-L","selects":"Documents_selects__3XRW_"};